import { render, staticRenderFns } from "./home-ramp.vue?vue&type=template&id=c91bf696"
import script from "./home-ramp.vue?vue&type=script&lang=js"
export * from "./home-ramp.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports